import type { OverridedMixpanel } from "mixpanel-browser";
import { createContext } from "react";

import type { HallowABFlag } from "../types/enums/HallowABFlag.enum";
import type { MixpanelABFlagValidProps } from "../types/enums/MixpanelABFlagValidProps.enum";

/** I would love to remove this just as soon as Mixpanel includes flags in their TS types */
export interface MixpanelWithFlags extends OverridedMixpanel {
  flags: {
    are_flags_ready: () => boolean;
    update_context: (context: any) => Promise<void>;
    get_variant: (
      key: string,
      fallback: any,
    ) => Promise<{ key: string; value: any }>;
    get_variant_sync: (
      key: string,
      fallback: any,
    ) => { key: string; value: any };
    get_variant_value: (key: string, fallback: any) => Promise<any>;
    get_variant_value_sync: (key: string, fallback: any) => any;
    is_enabled: (key: string, fallback: boolean) => Promise<boolean>;
    is_enabled_sync: (key: string, fallback: boolean) => boolean;
  };
}

export type MixpanelCustomProperties = {
  [key in (typeof MixpanelABFlagValidProps)[keyof typeof MixpanelABFlagValidProps]]?:
    | "true"
    | "false";
};
export type MixpanelUserContext = Record<string, any> & {
  custom_properties?: MixpanelCustomProperties;
};

export type FlagVariant = "control" | "treatment" | "excluded" | null;

export type MixpanelContext = {
  flags: {
    [key in HallowABFlag]?: {
      isTargeted: boolean;
      variant: FlagVariant;
    };
  };
  isLoading: boolean;
};

export const mixpanelContext = createContext<MixpanelContext>({
  flags: {},
  isLoading: true,
});
